import { Avatar, HStack, Text, VStack } from "@chakra-ui/react";
import { App } from "state/apps";
import { type AppTenantFields, appDisplayName } from "modules/apps/tenants";

const subtitleSizes = {
  sm: "xs",
  xs: "xs",
  md: "sm",
  lg: "md",
};

const AppIdentity = ({
  app,
  size = "sm",
  showSubtitle = true,
  imageSize,
}: {
  app: Pick<App, "name" | "domain"> &
    AppTenantFields & { links: { logoUrl: string } };
  size?: "sm" | "md" | "xs" | "lg";
  showSubtitle?: boolean;
  imageSize?: "sm" | "ms" | "xs" | "lg";
}) => {
  return (
    <HStack spacing={3}>
      <Avatar
        name={app.name || app.domain}
        size={imageSize ?? size}
        src={app.links.logoUrl}
      />
      <VStack spacing={0} align="flex-start">
        <Text
          isTruncated
          whiteSpace="pre-wrap"
          fontWeight={app.name ? "600" : "400"}
          variant={`${size}.m`}
          color={app.name ? "gray.900" : "gray.400"}
          size={size}
        >
          {appDisplayName(app)}
        </Text>
        {showSubtitle && (
          <Text
            fontSize={subtitleSizes[size]}
            color={app.domain ? "gray.600" : "gray.400"}
          >
            {app.domain || "No domain"}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export default AppIdentity;
